/**
 * BUCKS currency (working copy, homepage only):
 * Hidden on load / idle; visible while the shopper is active.
 * Revert: remove activity logic; keep non-homepage hide if needed.
 */
(function () {
  var IDLE_MS = 2800;
  var SHOW_CLASS = "tmn-currency-visible";
  var idleTimer = null;
  var lastMove = 0;

  function isHomepage() {
    return document.body && document.body.classList.contains("template-index");
  }

  function hideOffHomepage() {
    if (isHomepage()) return;
    var nodes = document.querySelectorAll(".buckscc-currency-box, .hxoSelectTheme");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.setProperty("display", "none", "important");
    }
  }

  function showCurrency() {
    if (!isHomepage() || document.hidden) return;
    document.body.classList.add(SHOW_CLASS);
    clearTimeout(idleTimer);
    idleTimer = setTimeout(hideCurrency, IDLE_MS);
  }

  function hideCurrency() {
    if (!document.body) return;
    /* Keep open while the shopper is picking a currency */
    if (document.querySelector(".buckscc-currency-box.open, .hxoSelectTheme.open, .buckscc-select-options[style*='block']")) {
      idleTimer = setTimeout(hideCurrency, IDLE_MS);
      return;
    }
    document.body.classList.remove(SHOW_CLASS);
  }

  function onActivity() {
    showCurrency();
  }

  function onMove() {
    var now = Date.now();
    if (now - lastMove < 200) return;
    lastMove = now;
    showCurrency();
  }

  function onVisibility() {
    if (document.hidden) {
      clearTimeout(idleTimer);
      if (document.body) document.body.classList.remove(SHOW_CLASS);
    }
  }

  function bind() {
    hideOffHomepage();
    if (!isHomepage()) return;

    document.body.classList.remove(SHOW_CLASS);

    var opts = { passive: true };
    window.addEventListener("scroll", onActivity, opts);
    window.addEventListener("wheel", onActivity, opts);
    window.addEventListener("touchstart", onActivity, opts);
    window.addEventListener("pointerdown", onActivity, opts);
    window.addEventListener("keydown", onActivity, opts);
    window.addEventListener("mousemove", onMove, opts);
    document.addEventListener("visibilitychange", onVisibility);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bind();
      setTimeout(hideOffHomepage, 800);
    });
  } else {
    bind();
    setTimeout(hideOffHomepage, 800);
  }
})();
